import { render, staticRenderFns } from "./StepSubjects.vue?vue&type=template&id=bfb6d26c&scoped=true&"
import script from "./StepSubjects.vue?vue&type=script&lang=js&"
export * from "./StepSubjects.vue?vue&type=script&lang=js&"
import style0 from "./StepSubjects.vue?vue&type=style&index=0&id=bfb6d26c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb6d26c",
  null
  
)

export default component.exports